import { render, staticRenderFns } from "./submenu-item.vue?vue&type=template&id=732c5ebf&scoped=true&"
import script from "./submenu-item.vue?vue&type=script&lang=js&"
export * from "./submenu-item.vue?vue&type=script&lang=js&"
import style0 from "./submenu-item.vue?vue&type=style&index=0&id=732c5ebf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732c5ebf",
  null
  
)

export default component.exports